// Recidiviz - a data platform for criminal justice reform
// Copyright (C) 2025 Recidiviz, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.
// =============================================================================

import { rem } from "polished";
import styled from "styled-components";

import {
  UsTnInitialClassification2026DraftData,
  UsTnReclassification2026DraftData,
} from "~datatypes";

import DOCXFormTextArea from "../../../DOCXFormTextArea";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const TextboxHeader = styled.div`
  font-size: ${rem(8)};
`;

export const TextAreaContainer = styled.div`
  & textarea {
    min-height: 3.5rem;
  }
`;

type DraftData = UsTnInitialClassification2026DraftData &
  UsTnReclassification2026DraftData;

export function TextboxWithHeader({
  header,
  name,
}: {
  header: string;
  name: Extract<keyof DraftData, string>;
}) {
  return (
    <Container>
      <TextboxHeader>{header}</TextboxHeader>
      <TextAreaContainer>
        <DOCXFormTextArea<DraftData> name={name} />
      </TextAreaContainer>
    </Container>
  );
}
